<template>
  <div class="dea-card-service" :style="cardStyles">
    <a :href="href" :title="title">
      <div v-if="headingText" class="dea-card-service__top" :style="cardDivideBorder">
        <div class="dea-card-service__heading dea-heading--regular__ms">{{ headingText }}</div>
      </div>
      <div class="dea-card-service__bottom">
        <div class="dea-card-service__logo-container">
          <PortalButtons class="dea-card-service__portal-button" :src="imgSrc" :href="href" :aria-label="ariaLabel" />
        </div>
        <div>
          <h2 class="dea-card-service__title dea-heading--medium__ms">{{ title }}</h2>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="dea-card-service__description dea-heading--light__xs" v-html="description"></div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import PortalButtons from "@/components/elements/PortalButtons";

export default {
  name: "CardService",
  components: { PortalButtons },
  props: {
    headingText: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    imgSrc: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "",
    },
    ariaLabel: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "",
    },
    outlineColor: {
      type: String,
      default: "",
    },
  },
  computed: {
    cardStyles() {
      const borderSize = this.outlineColor ? "3px" : "1px";
      const borderColor = this.outlineColor ? this.outlineColor : "#c8d1e0";
      const backgroundColor = this.bgColor ? this.bgColor : "#ffffff";
      return {
        background: backgroundColor,
        border: `${borderSize} solid ${borderColor}`,
      };
    },
    cardDivideBorder() {
      const borderBottom = this.outlineColor ? this.outlineColor : "#c8d1e0";
      return {
        "border-bottom": `1px solid ${borderBottom}`,
      };
    },
  },
};
</script>

<style lang="scss"></style>
